/**
 * Enum of URL query param keys used by the filter module.
 * This list is not exhaustive — the URL may include other params used by other modules.
 * Only use this enum for filter-related operations.
 */
export enum FilterParamKeys {
  TYPE = 'type',
  PAGE = 'page',
  LIMIT = 'limit',
  STATUS = 'status',
}
